export default {
  actionTypes: {
    loadMyPurchaseOrders: 'LOAD_MY_POs',
    updatePaginationInfo: 'UPDATE_PAGINATION_INFO',
    onFilterQueryChanged: 'ON_FILTER_QUERY_CHANGED',
  },
  mutationTypes: {
    setMyPurchaseOrders: 'SET_MY_POs',
    setMyPurchaseOrdersTotal: 'SET_MY_POs_TOTAL',
    setIsLoading: 'SET_IS_LOADING',
    setPaginationInfoPageNumber: 'SET_PAGINATION_PAGE_NUMBER',
    setPaginationInfoPageSize: 'SET_PAGINATION_PAGE_SIZE',
    setPaginationInfoSortBy: 'SET_PAGINATION_SORT_BY',
    setPaginationInfoSortOrder: 'SET_PAGINATION_SORT_ORDER',
    setFilterQuery: 'SET_FILTER_QUERY',
  },
};
